<mat-card class="mat-elevation-z0">
  <div class="d-flex align-items-center">
    <div>
      <mat-icon class="rounded-circle d-flex justify-content-center align-items-center">archive</mat-icon>
    </div>
    <div>test: {{fsItem.id}}</div>
    <div>
      <prada-fs-actions [fsItem]="fsItem"
        [fsStore]="fsStore"
        (fsItemActionClick)="onFsItemActionClick($event)"></prada-fs-actions>
    </div>
  </div>
</mat-card>